const PROJECT_KEY_GUARDS = {
  'OP3.0': {
    prefixes: [
      'old.',
      'MPS_',
      'Layout',
      'common.period',
    ],
    regex: /^[A-Za-z][A-Za-z0-9._-]*$/,
    allowedPunctuation: ['.', '_', '-'],
    allowedCharClass: /[A-Za-z0-9._-]/g,
  },
  'APP-3': {
    prefixes: ['MPS_'],
    regex: /^[A-Za-z][A-Za-z0-9_.-]*$/,
    allowedPunctuation: ['_', '.', '-'],
    allowedCharClass: /[A-Za-z0-9_.-]/g,
  },
}

/** Toast duration for key / excel validation failures (ms). */
export const VALIDATION_TOAST_MS = 12000

const PUNCT_LABELS = {
  _: '底線 _',
  '.': '句點 .',
  '-': '連字號 -',
}

function getGuard(project) {
  return PROJECT_KEY_GUARDS[project] || null
}

function matchesPrefix(key, prefixes) {
  return prefixes.some((prefix) => key.startsWith(prefix))
}

/**
 * @returns {boolean} true if project has no local guard, or key passes
 */
export function isKeyAllowed(project, key) {
  const guard = getGuard(project)
  if (!guard) return true
  if (!key) return false
  if (matchesPrefix(key, guard.prefixes)) return true
  return guard.regex.test(key)
}

function formatPunctuationList(chars) {
  return chars.map((ch) => PUNCT_LABELS[ch] || `「${ch}」`).join('、')
}

function describeForbiddenChar(ch) {
  if (ch === ' ') return '空白'
  if (ch === '\t') return 'Tab'
  if (ch === '\n') return '換行'
  if (ch === '\r') return '回車'
  return `「${ch}」`
}

function findDisallowedChars(key, guard) {
  const stripped = key.replace(guard.allowedCharClass, '')
  return [...new Set([...stripped])]
}

function describeGuard(project, guard) {
  const punct = formatPunctuationList(guard.allowedPunctuation)
  return [
    `允許前綴：${guard.prefixes.join('、')}`,
    `或一般格式：須以英文字母開頭；允許字元：英數 + 標點（${punct}）`,
    `其他標點／符號均不允許（例如 / : @ # 空白 等）`,
  ].join('\n')
}

function describeFailedKeys(failed, guard) {
  return failed
    .map((key) => {
      const bad = findDisallowedChars(key, guard)
      const parts = [`• ${key}`]
      if (key && !/^[A-Za-z]/.test(key) && !matchesPrefix(key, guard.prefixes)) {
        parts.push('  ─ 未以英文字母開頭')
      }
      if (bad.length > 0) {
        parts.push(
          `  ─ 不允許字元：${bad.map(describeForbiddenChar).join('、')}`,
        )
      }
      return parts.join('\n')
    })
    .join('\n')
}

/**
 * Validate new keys for projects with local guards.
 * @returns {string|undefined} error message if any key fails
 */
export function validateKeysForProject(project, inputKeys, existsKeyList = []) {
  const guard = getGuard(project)
  if (!guard) return

  const existsSet = new Set(existsKeyList)
  const newKeys = inputKeys.filter((key) => !existsSet.has(key))
  if (newKeys.length === 0) return

  const failed = newKeys.filter((key) => !isKeyAllowed(project, key))
  if (failed.length === 0) return

  return [
    `請求的 key 不符合 ${project} 規範：`,
    describeFailedKeys(failed, guard),
    '',
    describeGuard(project, guard),
  ].join('\n')
}
